import { useTranslation } from 'next-i18next'

import Checkbox from '@/components/Checkbox/Checkbox'

import { Content, ServicesList, ServicesTitle } from './Services.styled'
import { ServicesProps } from './Services.types'
import { useServices } from './useServices'

export default function Services({
  selectedServices,
  handleAddRemoveService,
  servicesOptions,
  title
}: ServicesProps) {
  const { t } = useTranslation('parkings')
  const { servicesOptions: defaultOptions } = useServices(t)

  const SelectedServicesOptions = servicesOptions || defaultOptions

  return (
    <Content>
      <ServicesTitle>{title}</ServicesTitle>
      <ServicesList>
        {SelectedServicesOptions.map(service => (
          <Checkbox
            key={service.title}
            text={service.title}
            value={service.value}
            isSelected={selectedServices.includes(service.value)}
            onChange={() => handleAddRemoveService(service.value)}
          />
        ))}
      </ServicesList>
    </Content>
  )
}
